"use client"

import type { ReactNode } from "react"

interface HomeAuthWrapperProps {
   newsFeed: ReactNode
}

export default function HomeAuthWrapper({ newsFeed }: HomeAuthWrapperProps) {
   return (
      <>
         <section className="w-full">{newsFeed}</section>
      </>
   )
}
